var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "\\u5408\\u6210-4",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    @keyframes a0_t { 0% { transform: translate(30px,60px) scale(1,1) translate(20.9px,2.9px); } 24% { transform: translate(60px,60px) scale(.7,.7) translate(20.9px,2.9px); } 48% { transform: translate(90px,60px) scale(1,1) translate(20.9px,2.9px); } 72% { transform: translate(62.3px,60px) scale(1.4,1.4) translate(20.9px,2.9px); } 96% { transform: translate(34.6px,60px) scale(1,1) translate(20.9px,2.9px); } 100% { transform: translate(30px,60px) scale(1,1) translate(20.9px,2.9px); } }\r\n    @keyframes a1_o { 0% { opacity: 1; } 48% { opacity: 1; } 52% { opacity: 0; } 100% { opacity: 0; } }\r\n    @keyframes a2_f { 0% { fill: #231fff; } 12% { fill: #1e1bb7; } 28% { fill: #1e1bb7; } 32% { fill: #1e1bb7; } 48% { fill: #231fff; } 100% { fill: #231fff; } }\r\n    @keyframes a3_t { 0% { transform: translate(90px,60px) scale(1,1) translate(20.9px,2.9px); } 24% { transform: translate(60px,60px) scale(1.4,1.4) translate(20.9px,2.9px); } 48% { transform: translate(30px,60px) scale(1,1) translate(20.9px,2.9px); } 72% { transform: translate(60px,60px) scale(.7,.7) translate(20.9px,2.9px); } 96% { transform: translate(90px,60px) scale(1,1) translate(20.9px,2.9px); } 100% { transform: translate(90px,60px) scale(1,1) translate(20.9px,2.9px); } }\r\n    @keyframes a4_f { 0% { fill: #2fe0d2; } 48% { fill: #2fe0d2; } 72% { fill: #1a7f77; } 96% { fill: #2fe0d2; } 100% { fill: #2fe0d2; } }\r\n    @keyframes a5_t { 0% { transform: translate(40px,60px) scale(1,1) translate(20.9px,2.9px); } 24% { transform: translate(65px,60px) scale(1,1) translate(20.9px,2.9px); } 36% { transform: translate(77.5px,60px) scale(1,1) translate(20.9px,2.9px); } 42% { transform: translate(83.8px,60px) scale(1,1) translate(20.9px,2.9px); } 48% { transform: translate(90px,60px) scale(1,1) translate(20.9px,2.9px); } 72% { transform: translate(62.3px,60px) scale(1.4,1.4) translate(20.9px,2.9px); } 96% { transform: translate(34.6px,60px) scale(1,1) translate(20.9px,2.9px); } 100% { transform: translate(30px,60px) scale(1,1) translate(20.9px,2.9px); } }\r\n    @keyframes a6_o { 0% { opacity: 0; } 48% { opacity: 0; } 52% { opacity: 1; } 100% { opacity: 1; } }\r\n    ")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30,60) translate(20.9,2.9)",
    style: {
      animation: "1s linear infinite both a0_t"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20.9,-2.9)",
    style: {
      animation: "1s linear infinite both a1_o"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231fff",
    d: "M0-12c6.6 0 12 5.4 12 12c0 6.6-5.4 12-12 12c-6.6 0-12-5.4-12-12c0-6.6 5.4-12 12-12Z",
    style: {
      animation: "1s linear infinite both a2_f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90,60) translate(20.9,2.9)",
    style: {
      animation: "1s linear infinite both a3_t"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20.9,-2.9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2fe0d2",
    d: "M0-12c6.6 0 12 5.4 12 12c0 6.6-5.4 12-12 12c-6.6 0-12-5.4-12-12c0-6.6 5.4-12 12-12Z",
    style: {
      animation: "1s linear infinite both a4_f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40,60) translate(20.9,2.9)",
    style: {
      animation: "1s linear infinite both a5_t"
    }
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    transform: "translate(-20.9,-2.9)",
    style: {
      animation: "1s linear infinite both a6_o"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231fff",
    d: "M0-12c6.6 0 12 5.4 12 12c0 6.6-5.4 12-12 12c-6.6 0-12-5.4-12-12c0-6.6 5.4-12 12-12Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerating);
export default __webpack_public_path__ + "static/media/generating.f72d7c135d180c9de0b86394cab2d791.svg";
export { ForwardRef as ReactComponent };